import { Link } from 'react-router-dom';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { useRobots } from '@/hooks/useRobots';

export default function NotFoundPage() {
  useDocumentMeta('Page Not Found');
  useRobots('noindex');
  return <div className="container mx-auto px-4 py-16 text-center">
    <h1 className="text-3xl font-bold mb-4">Page Not Found</h1>
    <p className="mb-6">The page you're looking for doesn't exist.</p>
    <Link to="/" className="text-primary underline">Back Home</Link>
  </div>;
}
